/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import {
  getAllocatorLoggingSettingsUrl,
  updateAllocatorLoggingSettingsUrl,
} from '@modules/cloud-api/v1/urls'
import type { LoggerLevel } from '@modules/ui-types'

import asyncRequest from '../asyncRequests'
import {
  FETCH_ALLOCATOR_LOGGING_SETTINGS,
  PATCH_ALLOCATOR_LOGGING_SETTINGS,
} from '../../constants/actions'

type PatchLoggingLevels = {
  [key: string]: LoggerLevel | null
}

export function fetchAllocatorLoggingSettings({
  regionId,
  allocatorId,
}: {
  regionId: string
  allocatorId: string
}) {
  return asyncRequest({
    type: FETCH_ALLOCATOR_LOGGING_SETTINGS,
    method: `GET`,
    url: getAllocatorLoggingSettingsUrl({ regionId, allocatorId }),
    meta: { regionId, allocatorId },
    crumbs: [regionId, allocatorId],
  })
}

export function patchAllocatorLoggingSettings({
  regionId,
  allocatorId,
  loggingLevels,
}: {
  regionId: string
  allocatorId: string
  loggingLevels: PatchLoggingLevels
}) {
  return asyncRequest({
    type: PATCH_ALLOCATOR_LOGGING_SETTINGS,
    method: `PATCH`,
    url: updateAllocatorLoggingSettingsUrl({ regionId, allocatorId }),
    meta: { regionId, allocatorId },
    crumbs: [regionId, allocatorId],
    payload: { logging_levels: loggingLevels },
  })
}
